export const goToSection = (id) => {
  if (window.location.pathname !== "/") {
    try {
      sessionStorage.setItem("edl-scroll-target", id);
    } catch (e) {}
    window.location.href = "/";
    return;
  }
  scrollToId(id);
};

export const consumePendingScrollTarget = () => {
  try {
    const id = sessionStorage.getItem("edl-scroll-target");
    if (id) {
      sessionStorage.removeItem("edl-scroll-target");
      return id;
    }
  } catch (e) {}
  return null;
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  window.scrollTo({
    top: el.getBoundingClientRect().top + window.scrollY - 80,
    behavior: "smooth",
  });
};
